import React from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import externalServiceIntegration from "../../../../assets/images/serviceManage/external-service-integration.png";
import systemSecurityConfig from "../../../../assets/images/serviceManage/system-security-config.png";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: externalServiceIntegration,
    label: "External Service Integration and Communication",
    description:
      "The Service Configuration module delivers seamless integration with external platforms through Email, Secure FTP, REST API, Log API, and Gemini services — establishing mission-critical communication channels for notifications and data synchronization. SMTP integration with TLS/SSL encryption powers automated alerts and status reports to designated recipients. Secure FTP delivers encrypted file transfer for bulletproof backup and remote sync. REST API and Log API unleash bidirectional data exchange with external apps, enabling real-time event streaming to monitoring systems and building management platforms. Each service maintains independent controls and authentication credentials for granular security.",
    imageLeft: true,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
  },
  {
    image: systemSecurityConfig,
    label: "System Operation and Security Configuration",
    description:
      "The Miscellaneous settings provide essential system-wide operational parameters including Two-Factor Authentication, Person Access Assignment, Mobile Credential management, and automated maintenance scheduling. Two-Factor Authentication enhances security by requiring secondary verification for user logins, with configurable policies supporting all users or selective user groups. Person Access Assignment determines whether access decisions evaluate credential-only authorization or combined credential and person verification. Mobile Credential Overwrite manages credential updates when users provision new mobile credentials, while Credential Required for Alert Clear ensures accountability by requiring credential presentation to acknowledge system alerts. Auto Update and Auto Reboot scheduling maintains system integrity through automated software updates and controlled system restarts during low-traffic periods.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#f8f8f8",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "392px",
    sectionHeight: "640px",
    textAlign: "right",
  },
];

export const ServiceManageContent = () => (
  <div className="bg-white w-full">
    <section
      className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
    >
      <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
        System Integration & Operational Security
      </h1>
      <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[792px]">
        Streamline external connectivity, strengthen authentication, and automate
        critical system operations for secure and efficient access management.
      </p>
    </section>

    <div className="w-full bg-white mt-6">
      {sections.map((section) => (
        <SectionBlock key={section.label} {...section} />
      ))}
    </div>
  </div>
);
